import { render } from "./PositionMagic.vue?vue&type=template&id=04e7e79c&ts=true"
import script from "./PositionMagic.vue?vue&type=script&lang=ts"
export * from "./PositionMagic.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__